module.exports = __webpack_public_path__ + "static/img/book12.87c7dcc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book12.jpg
// module id = jGPi
// module chunks = 1